import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ReduceToClearAction, ReduceToClearViewAction } from './reduce-to-clear.actions';
import { ReduceToClearService } from '../../service/reduce-to-clear.service';

@Injectable()
export class ReduceToClearEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private reduceToClearService: ReduceToClearService
  ) {}
  loadReduceToClearListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReduceToClearAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Reduce to Clear List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.reduceToClearService.getReduceToClearList(action.criteriaObj).pipe(
          map((data: any) => ReduceToClearAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  ReduceToClearView$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReduceToClearViewAction.request),
      tap((_) => this.logger.debug('@Effect Reduce To Clear View')),
      switchMap((action) => {
        return this.reduceToClearService.getReduceToClearView(action.docNo).pipe(
          map((data: any) => {
            return ReduceToClearViewAction.response({
              data
            });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
